import Vue from 'vue'
import { messages } from './messages'

function readStored() {
  try {
    const v = localStorage.getItem('locale')
    if (v === 'en' || v === 'zh') return v
  } catch (e) { /* noop */ }
  return 'zh'
}

// 轻量级响应式语言状态（无需额外依赖 vue-i18n）
export const i18n = new Vue({
  data: {
    locale: readStored()
  }
})

function resolve(dict, key) {
  return key.split('.').reduce((o, k) => (o == null ? undefined : o[k]), dict)
}

export function translate(key) {
  const dict = messages[i18n.locale] || messages.zh
  let val = resolve(dict, key)
  if (val === undefined) val = resolve(messages.zh, key)
  return val === undefined ? key : val
}

export function setLocale(l) {
  const next = l === 'en' ? 'en' : 'zh'
  i18n.locale = next
  try { localStorage.setItem('locale', next) } catch (e) { /* noop */ }
  if (typeof document !== 'undefined') {
    document.documentElement.lang = next === 'en' ? 'en' : 'zh-CN'
  }
}

export default {
  install(VueCtor) {
    // $t 在渲染中读取 i18n.locale，从而实现语言切换自动重渲染
    VueCtor.prototype.$t = function (key) {
      return translate(key)
    }
    VueCtor.prototype.$setLocale = function (l) {
      setLocale(l)
    }
    Object.defineProperty(VueCtor.prototype, '$locale', {
      get() { return i18n.locale }
    })
  }
}
